import styled from "styled-components";

export const ListPrograms = styled.div`
  width: 100%;
  height: 100%;
  background-color: #FFF;
  border-radius: 20px;
  .title {
    padding: 16.5px 20px;
    font-family: Nunito Sans Bold;
    font-size: 17px;
    border-bottom: 1px solid #E0E0FC;
    color: #1F1F52
  }
  .program-list {
    height: calc(100% - 57px);
    padding-left: 20px;
    padding-top: 20px;
    overflow-y: scroll;
    .program-item {
      margin-bottom: 10px;
      border-bottom: 1px solid #CFD3DD;
      &__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .program-info {
          color: #3E3E5B;
          .program-title {
            font-family: Nunito Sans Bold;
            font-size: 17px;            
          }
          .program-stage {
            font-family: Nunito Sans;
            font-size: 14px;
          }
        }
      }
      &__bottom {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .program-icon-clock {
          color: #0C0AA2;
          margin-right: 5px;
          font-size: 15px;
        }
        .item {
          &__title {
            font-family: Nunito Sans Bold;
            font-size: 12px;
            color: #3E3E5B;
          }
          &__description {
            font-family: Nunito Sans;
            font-size: 14px;
            color: #707582;
          }
        }
        .items-separator {
          height: 7px;
          border-right: #CFD3DD solid 1px;
          margin: 0 10px;
        }
      }
    }
  }
`